import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { milestones, stats, valores, propuestaValor } from "@/mocks/about";
import HechoEnMexicoSection from "@/pages/nosotros/components/HechoEnMexicoSection";

export default function NosotrosPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[70vh] min-h-[500px] flex items-end pb-16">
        <img
          src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/cae93feda8b818c5f1c750de5c80a995.png"
          alt="Nuestra Historia"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 w-full pt-20">
          <span className="text-[#7ee8f4] text-xs font-semibold uppercase tracking-widest">
            Nuestra Historia
          </span>
          <h1
            className="text-4xl md:text-6xl font-bold text-white mt-3 leading-tight max-w-2xl"
          >
            Más que una Pastelería, una Familia
          </h1>
          <p className="text-white/75 text-lg mt-4 max-w-xl">
            Desde 2022, creando momentos dulces con postres accesibles, innovadores y personalizados.
          </p>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-gradient-to-r from-[#00b4c8] via-[#0099aa] to-[#c9b8f0] py-10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-4xl font-bold text-white">{stat.value}</p>
              <p className="text-white/70 text-sm mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Quiénes Somos */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div>
              <span className="text-xs font-semibold text-[#00b4c8] uppercase tracking-widest">
                Quiénes somos
              </span>
              <h2
                className="text-3xl md:text-4xl font-bold text-[#2d1a0e] mt-3 mb-6 leading-tight"
              >
                Una empresa joven con más de 9 años de experiencia
              </h2>
              <p className="text-[#6b5b6e] text-base leading-relaxed mb-5">
                El <strong>24 de enero del 2022</strong> nace San7o Pecado como un emprendimiento familiar creado por la <strong>familia Domínguez Santana</strong>, con el sueño de llevar postres accesibles, innovadores y personalizados a cada celebración.
              </p>
              <p className="text-[#6b5b6e] text-base leading-relaxed mb-5">
                Ofrecemos postres pequeños para consentirte; además de pasteles, cupcakes, galletas, gelatinas y pasteles personalizados. Nos hemos posicionado como la opción <strong>práctica, linda y rica</strong> para pasteles personalizados.
              </p>
              <p className="text-[#6b5b6e] text-base leading-relaxed">
                Hoy contamos con <strong>36 sucursales</strong> y seguimos creciendo, llevando dulzura a más familias y celebraciones en toda la región.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/b1b137095807b7227b01425bbb6fbba0.png"
                alt="San7o Pecado - Negocio real"
                className="w-full h-52 object-cover object-top rounded-2xl"
              />
              <img
                src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/2c71e9123fc6018d1d2106548e737f9c.png"
                alt="San7o Pecado - Productos"
                className="w-full h-52 object-cover object-top rounded-2xl mt-6"
              />
              <img
                src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/df79e5b069e180564d1d54cb5b655ed0.png"
                alt="San7o Pecado - Equipo"
                className="w-full h-40 object-cover object-top rounded-2xl"
              />
              <img
                src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/0819445080cef2fc061b0c1d82446588.png"
                alt="San7o Pecado - Sucursal"
                className="w-full h-40 object-cover object-top rounded-2xl mt-6"
              />
            </div>
          </div>
        </div>
      </section>

      <HechoEnMexicoSection />

      {/* Misión & Visión */}
      <section className="py-20 bg-[#fdf8f5]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold text-[#00b4c8] uppercase tracking-widest">
              Nuestro propósito
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#2d1a0e] mt-2"
            >
              Misión y Visión
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-3xl overflow-hidden">
            <div className="bg-[#fff0f5] p-10 md:p-16">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#f9b8c8]/30 mb-6">
                <i className="ri-heart-line text-2xl text-[#d4607a]"></i>
              </div>
              <h3
                className="text-2xl font-bold text-[#2d1a0e] mb-5"
              >
                Nuestra Misión
              </h3>
              <p className="text-[#6b5b6e] text-base leading-relaxed">
                Ser parte de los mejores momentos de la vida de nuestros clientes con postres accesibles, innovadores y personalizados, siempre con cercanía, practicidad, servicio y valores inquebrantables.
              </p>
            </div>
            <div className="bg-[#f5f0ff] p-10 md:p-16">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#c9b8f0]/30 mb-6">
                <i className="ri-star-line text-2xl text-[#7c5cbf]"></i>
              </div>
              <h3
                className="text-2xl font-bold text-[#2d1a0e] mb-5"
              >
                Nuestra Visión
              </h3>
              <p className="text-[#6b5b6e] text-base leading-relaxed">
                Ser la pastelería de referencia en la región, reconocida por su accesibilidad y compromiso social, con presencia en cada reunión y celebración.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold text-[#00b4c8] uppercase tracking-widest">
              Lo que nos define
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#2d1a0e] mt-2"
            >
              Nuestros Valores
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {valores.map((v) => (
              <div
                key={v.title}
                className="bg-[#fdf8f5] rounded-2xl p-6 text-center hover:bg-[#fff0f5] transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#f9b8c8]/30 mx-auto mb-4">
                  <i className={`${v.icon} text-xl text-[#d4607a]`}></i>
                </div>
                <h4
                  className="text-base font-bold text-[#2d1a0e] mb-2"
                >
                  {v.title}
                </h4>
                <p className="text-[#6b5b6e] text-sm leading-relaxed">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Propuesta de Valor */}
      <section className="py-20 bg-gradient-to-br from-[#00b4c8] via-[#0099aa] to-[#c9b8f0]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold text-white/60 uppercase tracking-widest">
              Por qué elegirnos
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-white mt-2"
            >
              Nuestra Propuesta de Valor
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {propuestaValor.map((p) => (
              <div
                key={p.title}
                className="bg-white/15 border border-white/20 rounded-2xl p-6 text-center hover:bg-white/25 transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 mx-auto mb-4">
                  <i className={`${p.icon} text-xl text-white`}></i>
                </div>
                <h4
                  className="text-base font-bold text-white mb-2"
                >
                  {p.title}
                </h4>
                <p className="text-white/75 text-sm leading-relaxed">{p.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold text-[#00b4c8] uppercase tracking-widest">
              Nuestra trayectoria
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#2d1a0e] mt-2"
            >
              Historia de Crecimiento
            </h2>
          </div>
          <div className="relative">
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#c9b8f0]/50 -translate-x-1/2"></div>
            <div className="flex flex-col gap-12">
              {milestones.map((m, i) => (
                <div
                  key={`${m.year}-${m.title}`}
                  className={`flex flex-col md:flex-row items-center gap-6 ${
                    i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  <div className={`md:w-5/12 ${i % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                    <span className="text-[#00b4c8] font-bold text-sm uppercase tracking-widest">
                      {m.year}
                    </span>
                    <h3
                      className="text-xl font-bold text-[#2d1a0e] mt-1 mb-2"
                    >
                      {m.title}
                    </h3>
                    <p className="text-[#6b5b6e] text-sm leading-relaxed">{m.description}</p>
                  </div>
                  <div className="hidden md:flex w-2/12 justify-center">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-[#d4607a] to-[#7c5cbf] text-white font-bold text-xs border-4 border-white z-10">
                      {m.year.slice(2)}
                    </div>
                  </div>
                  <div className="md:w-5/12">
                    <img
                      src={m.image}
                      alt={m.title}
                      className={`w-full h-40 object-cover rounded-2xl ${'imagePosition' in m ? (m as { imagePosition: string }).imagePosition : 'object-top'}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
